(function () {
  function enhanceProductDescription(root) {
    if (!root) return;

    root.querySelectorAll('img:not([alt])').forEach(function (img) {
      var label = img.getAttribute('title') || img.closest('figure')?.querySelector('figcaption')?.textContent;
      img.setAttribute('alt', (label && label.trim()) || 'Product image');
    });

    root.querySelectorAll('a img').forEach(function (img) {
      var link = img.closest('a');
      if (!link) return;
      var linkText = link.textContent.trim();
      if (link.getAttribute('aria-label') || linkText) {
        img.setAttribute('alt', '');
        img.setAttribute('role', 'presentation');
      }
    });

    root.querySelectorAll('iframe:not([title])').forEach(function (frame, index) {
      frame.setAttribute('title', 'Embedded product content ' + (index + 1));
    });

    root.querySelectorAll('table').forEach(function (table) {
      if (!table.querySelector('th')) {
        table.setAttribute('role', 'presentation');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product__description-holder').forEach(enhanceProductDescription);
  });
})();
